export class AnnulerCorrection
{
    correctionId: String;
}